<router-outlet *ngIf="isHomePage"></router-outlet>
<div class="txp-main" *ngIf="!isHomePage">
    <txp-app-header class="header"
                    [logoImageSrc]="'/assets/images/man-user-icon-symbol.jpg'"
                    [logoAlt]="'img'">
    </txp-app-header>
    <txp-alt-nav class="nav"
                 [navConfig]="navConfig"
                 [currentRoute]="currentRoute"
                 *ngIf="!isCallCenterModeActive && !isResellerModeActive">
    </txp-alt-nav>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>
